import type { AudioEngine } from './engine';

/**
 * Browsers only start audio after a user gesture (autoplay policy). Every pointer or key press, caught
 * before anything else, asks a suspended engine to start; a running one is left alone, so a context
 * suspended by a hidden page is started again by the next interaction (a pause holds it: see the engine).
 */
export function bindAudioUnlock(engine: Pick<AudioEngine, 'unlock' | 'state'>, target: Window = window): () => void {
  const onInteraction = () => {
    if (engine.state === 'suspended') void engine.unlock();
  };
  target.addEventListener('pointerdown', onInteraction, { capture: true });
  target.addEventListener('keydown', onInteraction, { capture: true });
  return () => {
    target.removeEventListener('pointerdown', onInteraction, { capture: true });
    target.removeEventListener('keydown', onInteraction, { capture: true });
  };
}
